import { fetchLoyaltyAccountRequest } from "app/modules/loyalty/reducer/actions";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { accountDetailRequest, customerPositionRequest, limitRemainRequest, listAccountRequest, listAccountRequestLogin } from "../services/account-manager";
import {
  fetchAccountDetailFailure,
  fetchAccountDetailSuccess,
  fetchCustomerPositionFailure,
  fetchCustomerPositionRequest,
  fetchCustomerPositionSuccess,
  fetchLimitRemainFailure,
  fetchLimitRemainSuccess,
  fetchListAccountLoginFailure,
  fetchListAccountLoginSuccess,
  fetchListAccountFailure,
  fetchListAccountSuccess,
} from "./actions";
import {
  FETCH_ACCOUNT_DETAIL_REQUEST,
  FETCH_CUSTOMER_POSITION_REQUEST,
  FETCH_LIMIT_REMAIN_REQUEST,
  FETCH_LIST_ACCOUNT_LOGIN_REQUEST,
  FETCH_LIST_ACCOUNT_REQUEST,
} from "./actions.type";
import { FetchAccountDetailRequest } from "./types";

function* fetchListAccountLoginSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(listAccountRequestLogin);
    console.log("fetchListAccountLogin response: ", response);
    if (response.status === 200) {
      yield put(fetchListAccountLoginSuccess(response.data.RESPONSEDATA, response.data?.HEADER?.HASKEY, response.data?.HEADER?.SIGNATURE));
    }
  } catch (e: AxiosError | any) {
    console.log("e: ", e);
    yield put(fetchListAccountLoginFailure());
    getErrorMessage(e, true, true);
  }
}

function* fetchListAccountSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(listAccountRequest);
    console.log("ListAccount response: ", response);
    if (response.status === 200) {
      yield put(fetchListAccountSuccess(response.data.RESPONSEDATA, response.data?.HEADER?.HASKEY, response.data?.HEADER?.SIGNATURE));
      yield put(fetchCustomerPositionRequest());
      yield put(fetchLoyaltyAccountRequest());
    }
  } catch (e: AxiosError | any) {
    console.log("e: ", e);
    yield put(fetchListAccountFailure());
    getErrorMessage(e, true);
  }
}

function* fetchAccountDetailSaga(action: FetchAccountDetailRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => accountDetailRequest(action));
    console.log("Account detail: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const accountProfile = response.data.RESPONSEDATA?.ACCOUNTPROFILE;
      yield put(fetchAccountDetailSuccess(accountProfile));
    }
  } catch (e: AxiosError | any) {
    yield put(hideModal());
    yield put(fetchAccountDetailFailure());
    getErrorMessage(e, true);
  }
}

function* fetchLimitRemainSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(limitRemainRequest);
    console.log("LimitRemain response: ", response);
    if (response.status === 200) {
      const limitRemain = response.data.RESPONSEDATA?.USERPROFILE?.LIMIT_REMAIN;
      yield put(fetchLimitRemainSuccess(limitRemain));
    }
  } catch (e: AxiosError | any) {
    console.log("e: ", e);
    yield put(fetchLimitRemainFailure());
    getErrorMessage(e, false);
  }
}

function* fetchCustomerPositionSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(customerPositionRequest);
    console.log("ListAccount response: ", response);
    if (response.status === 200) {
      yield put(fetchCustomerPositionSuccess(response.data.RESPONSEDATA?.LIST_ACCOUNT_PROFILE?.ACCOUNT));
    }
  } catch (e: AxiosError | any) {
    console.log("e: ", e);
    yield put(fetchCustomerPositionFailure());
  }
}

function* accountSaga() {
  yield all([
    takeLatest(FETCH_LIST_ACCOUNT_LOGIN_REQUEST, fetchListAccountLoginSaga),
    takeLatest(FETCH_LIMIT_REMAIN_REQUEST, fetchLimitRemainSaga),
    takeLatest(FETCH_ACCOUNT_DETAIL_REQUEST, fetchAccountDetailSaga),
    takeLatest(FETCH_LIST_ACCOUNT_REQUEST, fetchListAccountSaga),
    takeLatest(FETCH_CUSTOMER_POSITION_REQUEST, fetchCustomerPositionSaga),
  ]);
}

export default accountSaga;
